module.exports = __webpack_public_path__ + "media/images/clearbanc-ventures-logo-st-26d3ad0321760bc89312fb3b8d52aaf0.svg";